<div class="stats">
    <p class="value">{{value}}</p>
    <p class="label">{{label}}</p>
</div>
